import { render, staticRenderFns } from "./Third.vue?vue&type=template&id=fed67b5c&scoped=true&"
import script from "./Third.vue?vue&type=script&lang=js&"
export * from "./Third.vue?vue&type=script&lang=js&"
import style0 from "./Third.vue?vue&type=style&index=0&id=fed67b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed67b5c",
  null
  
)

export default component.exports